import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';

import MultiSelect from 'components/fields/MultiSelect';
import { useAnswerCodes } from '../../hooks/useAnswerCodes';

interface RenewalCarriersModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedCodes: string[];
  onSave: (codes: string[]) => void;
}

const RenewalCarriersModal = ({
  isOpen,
  onClose,
  selectedCodes,
  onSave,
}: RenewalCarriersModalProps) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const { getOptions, isLoading } = useAnswerCodes();
  const insurerOptions = getOptions('current_insurer').filter(
    (opt) => opt.value !== '',
  );

  const carrierItems = insurerOptions.map((opt) => ({
    id: parseInt(opt.value as string, 10),
    name: opt.label,
  }));

  useEffect(() => {
    if (isOpen) {
      const ids = selectedCodes.map((code) => parseInt(code, 10));
      setSelectedIds(ids);
    }
  }, [isOpen, selectedCodes]);

  const handleSave = () => {
    const codes = selectedIds.map((id) => id.toString());
    onSave(codes);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Renewal Carriers</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <MultiSelect
            label="Search carriers..."
            selectedIds={selectedIds}
            availableItems={carrierItems}
            isLoading={isLoading}
            onChange={setSelectedIds}
            itemLabelSingular="carrier"
            itemLabelPlural="carriers"
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="brand" onClick={handleSave}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RenewalCarriersModal;
